import { Box, Button, Link as MuiLink, Typography } from '@mui/material';
import React from 'react';
import { GoogleButton } from 'src/components/google-btn';
import { Screen } from 'src/components/screen';

import {
  container,
  title,
  contentContainer,
  detail,
  contactUs,
  googleBtn,
  root,
  legalLinksContainer,
  legalLink,
} from './styles';
import { useTranslation } from 'src/text';
import { t2 } from 'src/themes/custom';
import { Link as RouterLink } from 'react-router-dom';

const LoginScreen: React.FC = () => {
  const { genericLabels, loginLabels } = useTranslation();

  const handleContactUsPressed = () => {};
  return (
    <Screen contentContainerStyle={root}>
      <Box sx={container}>
        <Typography />
        <Box sx={contentContainer}>
          <Typography sx={title}>{loginLabels.signIn}</Typography>
          <Typography sx={detail}>{loginLabels.detail}</Typography>
          <Box sx={googleBtn}>
            <GoogleButton />
          </Box>
          <Box sx={contactUs}>
            <Typography sx={t2}>{loginLabels.new}</Typography>
            <Button
              variant="text"
              color="secondary"
              onClick={handleContactUsPressed}>
              <Typography color={'secondary'} sx={t2}>
                {genericLabels.contactUs}
              </Typography>
            </Button>
          </Box>

          {/* Legal links footer - visible on home/login for policy compliance */}
          <Box sx={legalLinksContainer}>
            <MuiLink
              component={RouterLink}
              to="/privacy-policy"
              underline="hover"
              sx={legalLink}>
              {genericLabels.privacy}
            </MuiLink>
            <MuiLink
              component={RouterLink}
              to="/terms-of-use"
              underline="hover"
              sx={legalLink}>
              {genericLabels.terms}
            </MuiLink>
          </Box>
        </Box>
      </Box>
    </Screen>
  );
};

export { LoginScreen };
